import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["stockDisplay", "variant", "colorVariant", "quantity", "useStock"]
  static values = {
    moldedCandleId: Number
  }

  connect() {
    console.log('Molded candle stock controller connected')
    console.log('Targets:', this.hasVariantTarget, this.hasQuantityTarget, this.hasStockDisplayTarget)
    console.log('Values:', this.moldedCandleIdValue)
    this.loadColorVariants()
    this.updateStock()
  }

  loadColorVariants() {
    const variantId = this.hasVariantTarget ? this.variantTarget.value : null

    if (!variantId || !this.hasColorVariantTarget) {
      return
    }

    // Fetch the molded_candle_id for this variant to load its color variants
    fetch(`/crafting/molded_candles/${this.moldedCandleIdValue}/variants/${variantId}/color_variants`, {
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      const currentValue = this.colorVariantTarget.value
      this.colorVariantTarget.innerHTML = '<option value="">Aucune (optionnel)</option>'

      data.color_variants.forEach(cv => {
        const option = document.createElement('option')
        option.value = cv.id
        option.textContent = cv.name
        if (cv.id.toString() === currentValue) {
          option.selected = true
        }
        this.colorVariantTarget.appendChild(option)
      })
    })
    .catch(error => {
      console.error('Error fetching color variants:', error)
    })
  }

  updateStock() {
    // First load color variants when variant changes
    this.loadColorVariants()

    const quantity = parseInt(this.quantityTarget.value) || 1
    const useStock = this.hasUseStockTarget ? this.useStockTarget.checked : true
    const variantId = this.hasVariantTarget ? this.variantTarget.value : null
    const colorVariantId = this.hasColorVariantTarget ? this.colorVariantTarget.value : ''

    if (!variantId) {
      this.stockDisplayTarget.innerHTML = '<p class="text-muted text-center">Aucune variante sélectionnée</p>'
      return
    }

    let url = `/crafting/molded_candles/${this.moldedCandleIdValue}/calculate_stock?quantity=${quantity}&use_stock=${useStock}&variant_id=${variantId}`
    if (colorVariantId) {
      url += `&color_variant_id=${colorVariantId}`
    }

    fetch(url, {
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      this.stockDisplayTarget.innerHTML = data.html
    })
    .catch(error => {
      console.error('Error fetching stock:', error)
    })
  }
}

